import React from 'react';
import "./Header.css";
import svgPaths from "../../imports/Dash/svg-drwaidsec3.ts";

export function Header() {
  return (
    <header className="header">
      <div className="header-search-wrapper">
        <div className="header-search-icon">
          <svg fill="none" preserveAspectRatio="none" viewBox="0 0 12.8942 12.8942" width="12.894" height="12.894">
            <path d={svgPaths.pe8ef280} fill="#AAABAF" />
          </svg>
        </div>
        <input
          className="header-search-input"
          placeholder="Search analytics, attendees, or sessions..."
        />
      </div>

      <div className="header-session">
        <div className="header-divider" />
        <div className="header-session-text">
          Session: <span>Day 01</span>
        </div>
      </div>
    </header>
  );
}